import { formatMonto } from "@/utils";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
export const ColumnsTCustomer = [
  {
    prop: "ClienteId",
    label: "Cliente ID",
    width: "180",
    sortable: true
  },
  {
    prop: "RNC",
    label: "RNC",
    sortable: true,
    width: "180"
  },
  {
    prop: "Name",
    label: "Nombre",
    sortable: true
  },
  {
    prop: "Tansactions_Total",
    label: "Transaction Total",
    sortable: true,
    formatter: (row) => formatMonto(row.Tansactions_Total)
  }
];

export const ColumnsTransactiDay = [
  {
    prop: "Dia",
    label: "Dia",
    sortable: true,
    formatter: DatetimeFormatter
  },
  {
    prop: "transactions",
    label: "Transaction",
    sortable: true
  }
];

export const ColumnsTProveedores = [
  {
    prop: "EmpresaId",
    label: "Empresa ID",
    width: "180",
    sortable: true
  },
  {
    prop: "RNC",
    label: "RNC",
    sortable: true,
    width: "180"
  },
  {
    prop: "Name",
    label: "Nombre",
    sortable: true
  },
  {
    prop: "Tansactions_Total",
    label: "Transaction Total",
    sortable: true,
    formatter: (row) => formatMonto(row.Tansactions_Total)
  }
];

export const ColumnsTransactiType = [
  {
    prop: "Name",
    label: "Nombre",
    sortable: true
  },
  {
    prop: "Tansactions_Total",
    label: "Transaction Total",
    sortable: true
  }
];

export const ColumnsTransactiHours = [
  {
    prop: "Dia",
    label: "Dia",
    sortable: true,
    formatter: DatetimeFormatter
  },
  {
    prop: "Hora",
    label: "Hora",
    sortable: true
  },
  {
    prop: "transactions",
    label: "Transaction",
    sortable: true
  }
];
export const ColumnsTransactiminutos = [
  {
    prop: "minuto",
    label: "Minutos",
    sortable: true
  },
  {
    prop: "transactions",
    label: "Transaction",
    sortable: true
  }
];
